import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";
import { Card, Col, Row } from "react-bootstrap";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { DB_POSTFIX, getFileLiveUrl } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";

const TestimonialsList = (props) => {
  const [windowSize, setWindowSize] = useState(null);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    listData();
  }, []);

  const listData = () => {
    setLoader(true);
    axios
      .get(
        ServiceUrl.LIST_PAGES +
          "?sadb=" +
          DB_POSTFIX +
          "&type=testimonial&limit=12"
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
          //  console.log(res["data"].data);
        }
        setLoader(false);
      });
  };

  useEffect(() => {
    const handleResize = () => {
      // Perform actions on window resize
      //setWindowSize([window.innerWidth, window.innerHeight]);
      setWindowSize(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setWindowSize(window.innerWidth);
  }, []);

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
  };

  const getCard = (item) => {
    return (
      <div className="text-center px-3">
        <p
          className="text-capitalize"
          style={{
            fontStyle: "italic",
            maxWidth: "700px",
            margin: "0 auto",
            fontSize: "13px",
          }}
        >
          {item.content_html}
        </p>
        <div className="mt-3 d-flex flex-column gap-2 justify-content-center align-items-center">
          <img
            src={getFileLiveUrl(item.feature_image)}
            alt={item.title}
            className="rounded-circle"
            style={{ width: "70px", height: "70px", objectFit: "cover" }}
          />
          <div className="mt-2">{item.title}</div>
        </div>
      </div>
    );
  };

  return (
    <>
      <section>
        <div className="container">
          <p className="announcement-title">Testimonials</p>
          <Slider {...settings}>{dataList.map((item) => getCard(item))}</Slider>
        </div>
      </section>
    </>
  );
};

export default TestimonialsList;
